import { useState } from 'react';
import { Box, List, ListItemButton, ListItemText, Collapse } from '@mui/material';
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { CertLocation } from '../types';

type LocationListItem = CertLocation & {
  open?: boolean;
};

type LocationListProps = {
  locations: CertLocation[];
};

const Locations = ({ locations }: LocationListProps) => {
  const { t } = useTranslation();
  const [locationsData, setLocationsData] = useState<LocationListItem[]>(locations);

  const handleClick = (id: string) => {
    const newList = locationsData.map((loc) => {
      if (id === loc.id) {
        const tmp = {
          ...loc,
          open: !loc.open,
        };
        return tmp;
      }
      return loc;
    });

    setLocationsData(newList);
  };

  const renderExpandButton = (loc: LocationListItem) => {
    if (loc.open) {
      return <ExpandLessIcon />;
    }
    if (!loc.open) {
      return <ExpandMoreIcon />;
    }
    return null;
  };

  return (
    <List
      sx={{ mt: 5, width: '100%', borderRadius: '4px', boxShadow: 1 }}
      component="div"
      aria-labelledby="certmdlocation-list"
    >
      {locationsData.map((location) => (
        <Box component="div" key={location.id}>
          <ListItemButton onClick={() => handleClick(location.id)}>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.25rem' }}
              secondaryTypographyProps={{ fontSize: '1rem' }}
              primary={location.name ?? 'N/A'}
            />
            {renderExpandButton(location)}
          </ListItemButton>

          {locationsData?.length > 0 ? (
            <Collapse in={location.open} timeout="auto" unmountOnExit>
              <List component="div" dense disablePadding>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText
                    primaryTypographyProps={{ fontSize: '1.25rem' }}
                    secondaryTypographyProps={{ fontSize: '1rem' }}
                    primary={location.address ?? 'N/A'}
                  />
                </ListItemButton>
              </List>
            </Collapse>
          ) : null}
        </Box>
      ))}
    </List>
  );
};

export default Locations;
